import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, OnDestroy, Output, EventEmitter, OnInit, inject, PLATFORM_ID } from '@angular/core';

@Directive({
    selector: '[appResizeObserver]',
})
export class ResizeObserverDirective implements OnDestroy, OnInit {
    @Output() appResizeObserver = new EventEmitter<DOMRectReadOnly>();

    private elementRef = inject(ElementRef);
    private platformId = inject(PLATFORM_ID);
    private observer?: ResizeObserver;

    ngOnInit() {
        if (isPlatformBrowser(this.platformId) && typeof ResizeObserver !== 'undefined') {
            this.observer = new ResizeObserver((entries) => {
                for (const entry of entries) {
                    this.appResizeObserver.emit(entry.contentRect);
                }
            });
            this.observer.observe(this.elementRef.nativeElement);
        }
    }

    ngOnDestroy() {
        if (this.observer) {
            this.observer.unobserve(this.elementRef.nativeElement);
            this.observer.disconnect();
        }
    }
}
